import { render, staticRenderFns } from "./photo-tailor.vue?vue&type=template&id=65c9a55a&scoped=true"
import script from "./photo-tailor.vue?vue&type=script&lang=js"
export * from "./photo-tailor.vue?vue&type=script&lang=js"
import style0 from "./photo-tailor.vue?vue&type=style&index=0&id=65c9a55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9a55a",
  null
  
)

export default component.exports